import React, { useState, useEffect, useRef } from "react";
import classNames from "classnames";
import UserInvitesList from "components/UserInvitesList";
import TeamService from "services/TeamService";
import { ReactComponent as InvitationIcon } from "assets/img/icons/invitation_h.svg";
import { InvitationsContext } from "store/contexts/invitationContext";
import { CSSTransition } from "react-transition-group";

export default ({ newInvitation, newInvitationData, setNewInvitation }) => {
  const [invitationOpen, setInvitationOpen] = useState(false);
  const [invitations, setInvitations] = useState([]);
  const [invitationTotal, setInvitationTotal] = useState("");
  const [invitationPage, setInvitationPage] = useState(1);
  const [rejectModalOpen, setRejectModalOpen] = useState(false);
  const [rejectInviteCode, setRejectInviteCode] = useState();
  const [isLoading, setIsLoading] = useState(true);
  const box = useRef(0);

  const closeInviations = () => {
    if (!rejectModalOpen) {
      setNewInvitation(false);
      handleCloseInvitation();
      return;
    }
  };

  const handleCloseInvitation = () => {
    setInvitationOpen(false);
  };

  const handleInvitation = () => {
    setInvitationOpen(true);
  };

  useEffect(() => {
    if (!newInvitationData) {
      return;
    }

    createInvitation(newInvitationData);

    //eslint-disable-next-line
  }, [newInvitationData]);

  useEffect(() => {
    try {
      (async () => {
        const response = await TeamService.getInvites(invitationPage);

        setInvitations(
          Array.from(new Set([...invitations, ...response?.data?.data]))
        );
        setInvitationTotal(response?.data?.total);
        setIsLoading(false);
      })();
    } catch (e) {
      console.log(e);
    }

    // eslint-disable-next-line
  }, [invitationPage]);

  const getNextInvitationPageData = () => {
    setIsLoading(true);
    setInvitationPage(invitationPage + 1);
  };

  const incrementTotal = () => {
    setInvitationTotal(invitationTotal + 1);
  };

  const createInvitation = (invitation) => {
    if (!invitation) {
      return;
    }

    setInvitations(Array.from(new Set([invitation, ...invitations])));

    incrementTotal();
  };

  return (
    <>
      <p
        ref={box}
        onClick={handleInvitation}
        className={classNames({
          "invitations_icon collapsed": true,
          //eslint-disable-next-line
          [" " + "active"]: invitationOpen && true,
        })}
      >
        {Boolean(invitationTotal) && (
          <span className="totalInvites">{invitationTotal}</span>
        )}
        <InvitationIcon className="rightHeaderIcon" />
      </p>
      <CSSTransition
        in={invitationOpen}
        timeout={300}
        unmountOnExit
        classNames="dropdown-element"
      >
        <InvitationsContext.Provider
          value={{
            closeInviations,
            setRejectModalOpen,
            rejectModalOpen,
            setRejectInviteCode,
            rejectInviteCode,
          }}
        >
          <UserInvitesList
            isLoading={isLoading}
            invitations={invitations}
            getNextInvitationPageData={getNextInvitationPageData}
            setInvitations={setInvitations}
            invitationTotal={invitationTotal}
            setInvitationTotal={setInvitationTotal}
          />
        </InvitationsContext.Provider>
      </CSSTransition>
    </>
  );
};
